import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/_externalProjectionsLayout/dashboards/create')({
  beforeLoad: () => getTitleContextSlice('Create Dashboard'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
